<div class="imageContainer">
  <img class="circle-name-m" [src]="'./assets/img/home365_logo_small.svg'" alt="image"/>
</div>
<div class="messageDataContainer" >
  <header>
    <div class="name">{{'SERVICE_REVIEW.SENDER_NAME' | translate}}</div>
    <div class="date">{{serviceReviewDate.value | date : !serviceReviewDone ? 'M/d/yy, h:mm a' : 'M/d/yy'}}</div>
  </header>
  <form [formGroup]="form" class="body" >
    <div class="title">{{'SERVICE_REVIEW.TITLE_1' | translate}}</div>
    <div class="subTitle">{{'SERVICE_REVIEW.TITLE_2' | translate}}</div>
    <div class="ScoresRow" [ngClass]="{'mobileScoresRow': isMobile}">
      <div class="Score" *ngFor="let question of questions" (click)="setValue(question)" [ngClass]="{'active': serviceReviewScore.value === question.value,'done' : serviceReviewDone, 'mobileScore': isMobile}">
        <div class="icon">
          <i class="fa-light" [ngClass]="question.icon"></i>
        </div>
        <div class="iconText">{{question.icon_text}}</div>
      </div>
    </div>
    <div class="title" *ngIf="serviceReviewQuestion.value && !serviceReviewDone">{{serviceReviewQuestion.value}}</div>
    <div class="subTitle" *ngIf="serviceReviewDone"> {{'SERVICE_REVIEW.YOUR_FEEDBACK' | translate}}</div>
    <div class="title" *ngIf="serviceReviewDone">{{serviceReviewAnswer.value}}</div>
    <textarea 
      *ngIf="serviceReviewQuestion.value && !serviceReviewDone" 
      cdkTextareaAutosize 
      cdkAutosizeMinRows="1" 
      cdkAutosizeMaxRows="10" 
      formControlName="serviceReviewAnswer" 
      [ngClass]="{'mobileTextarea': isMobile}"
      #serviceReviewAnswerInput
      placeholder="{{'SERVICE_REVIEW.PLACEHOLDER' | translate}}" 
    ></textarea>
    <div class="errorRow" *ngIf="serviceReviewQuestion.value && !serviceReviewDone" [ngClass]="{'withError': serviceReviewAnswer.hasError('maxlength'),'mobileErrorRow' : isMobile}">
      <div class="error" *ngIf="serviceReviewAnswer.hasError('maxlength')">
        {{'SERVICE_REVIEW.MAX_CHARACTERS_ERROR' | translate  }}
      </div>
      <!-- <div class="hint" [ngClass]="{'hintWithError': serviceReviewAnswer.hasError('maxlength')}">{{serviceReviewAnswer?.value ? serviceReviewAnswer?.value?.length : 0}}/{{maxInputLength}}</div> -->
    </div>
  </form>
  <div class="footer" [ngClass]="{'mobileFooter': isMobile}" >
    <div class="submitted_text" *ngIf="serviceReviewDone"><i class="fa-solid fa-check"></i> {{'SERVICE_REVIEW.FEEDBACK_SUBMITTED' | translate}}</div>
    <button mat-button *ngIf="!serviceReviewDone" class="home365-button primary" (click)="submit()" [disabled]="form.invalid" [ngClass]="{'mobilebutton': isMobile}">{{'SERVICE_REVIEW.BUTTON_TEXT' | translate}}</button>
  </div>
</div>